export const translations = {
  en: {
    nav: {
      services: "Services",
      contact: "Contact"
    },
    hero: {
      title: "Valtellina Software",
      subtitle: "Innovative Software Solutions",
      description: "We transform ideas into powerful digital solutions. From automation to game development, we deliver excellence.",
      cta: "Get Started"
    },
    services: {
      title: "Our Services",
      automation: {
        title: "Automation & Infrastructure",
        description: "Process automation, database management, and client-server infrastructure solutions that streamline your operations and boost efficiency.",
        features: ["Process Automation", "Database Management", "Client-Server Infrastructure", "System Integration"]
      },
      fullCycle: {
        title: "Full-Cycle Development",
        description: "Turnkey project development from concept to release. We handle every stage of your project with precision and expertise.",
        features: ["Idea to Implementation", "Project Management", "Quality Assurance", "Release & Deployment"]
      },
      gameDev: {
        title: "Game Development & VR",
        description: "PC and mobile game development, VR simulators from concept to store release. Immersive experiences that captivate users.",
        features: ["PC & Mobile Games", "VR Simulators", "Unity & Unreal Engine", "Store Publishing"]
      }
    },
    contact: {
      title: "Let's Work Together",
      subtitle: "Ready to start your project? Get in touch with us today.",
      form: {
        name: "Your Name",
        email: "Your Email",
        company: "Company Name",
        message: "Project Details",
        submit: "Send Request",
        sending: "Sending...",
        success: "Thank you! We'll contact you soon.",
        error: "Something went wrong. Please try again.",
        validation: {
          nameRequired: "Please enter your name",
          emailRequired: "Please enter your email",
          emailInvalid: "Please enter a valid email address",
          messageRequired: "Please enter your message"
        }
      }
    },
    footer: {
      tagline: "Building the future, one solution at a time.",
      rights: "All rights reserved."
    }
  },
  de: {
    nav: {
      services: "Dienstleistungen",
      contact: "Kontakt"
    },
    hero: {
      title: "Valtellina Software",
      subtitle: "Innovative Softwarelösungen",
      description: "Wir verwandeln Ideen in leistungsstarke digitale Lösungen. Von Automatisierung bis Spieleentwicklung liefern wir Exzellenz.",
      cta: "Loslegen"
    },
    services: {
      title: "Unsere Dienstleistungen",
      automation: {
        title: "Automatisierung & Infrastruktur",
        description: "Prozessautomatisierung, Datenbankverwaltung und Client-Server-Infrastrukturlösungen zur Optimierung Ihrer Abläufe.",
        features: ["Prozessautomatisierung", "Datenbankverwaltung", "Client-Server-Infrastruktur", "Systemintegration"]
      },
      fullCycle: {
        title: "Full-Cycle Entwicklung",
        description: "Schlüsselfertige Projektentwicklung vom Konzept bis zur Veröffentlichung. Wir kümmern uns um jede Phase Ihres Projekts.",
        features: ["Idee bis Umsetzung", "Projektmanagement", "Qualitätssicherung", "Release & Deployment"]
      },
      gameDev: {
        title: "Spieleentwicklung & VR",
        description: "PC- und Mobile-Spieleentwicklung, VR-Simulatoren vom Konzept bis zur Store-Veröffentlichung.",
        features: ["PC & Mobile Spiele", "VR-Simulatoren", "Unity & Unreal Engine", "Store-Veröffentlichung"]
      }
    },
    contact: {
      title: "Lassen Sie uns zusammenarbeiten",
      subtitle: "Bereit, Ihr Projekt zu starten? Kontaktieren Sie uns noch heute.",
      form: {
        name: "Ihr Name",
        email: "Ihre E-Mail",
        company: "Firmenname",
        message: "Projektdetails",
        submit: "Anfrage senden",
        sending: "Wird gesendet...",
        success: "Vielen Dank! Wir werden Sie bald kontaktieren.",
        error: "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
        validation: {
          nameRequired: "Bitte geben Sie Ihren Namen ein",
          emailRequired: "Bitte geben Sie Ihre E-Mail ein",
          emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
          messageRequired: "Bitte geben Sie Ihre Nachricht ein"
        }
      }
    },
    footer: {
      tagline: "Die Zukunft gestalten, eine Lösung nach der anderen.",
      rights: "Alle Rechte vorbehalten."
    }
  },
  it: {
    nav: {
      services: "Servizi",
      contact: "Contatto"
    },
    hero: {
      title: "Valtellina Software",
      subtitle: "Soluzioni Software Innovative",
      description: "Trasformiamo le idee in potenti soluzioni digitali. Dall'automazione allo sviluppo di giochi, offriamo eccellenza.",
      cta: "Inizia Ora"
    },
    services: {
      title: "I Nostri Servizi",
      automation: {
        title: "Automazione & Infrastruttura",
        description: "Automazione dei processi, gestione database e soluzioni infrastrutturali client-server per ottimizzare le operazioni.",
        features: ["Automazione Processi", "Gestione Database", "Infrastruttura Client-Server", "Integrazione Sistemi"]
      },
      fullCycle: {
        title: "Sviluppo Full-Cycle",
        description: "Sviluppo progetti chiavi in mano dal concetto al rilascio. Gestiamo ogni fase del progetto con precisione ed esperienza.",
        features: ["Dall'Idea all'Implementazione", "Gestione Progetti", "Garanzia Qualità", "Release & Deployment"]
      },
      gameDev: {
        title: "Sviluppo Giochi & VR",
        description: "Sviluppo giochi PC e mobile, simulatori VR dal concetto al rilascio negli store. Esperienze immersive che catturano gli utenti.",
        features: ["Giochi PC & Mobile", "Simulatori VR", "Unity & Unreal Engine", "Pubblicazione Store"]
      }
    },
    contact: {
      title: "Lavoriamo Insieme",
      subtitle: "Pronti ad avviare il vostro progetto? Contattateci oggi stesso.",
      form: {
        name: "Il Tuo Nome",
        email: "La Tua Email",
        company: "Nome Azienda",
        message: "Dettagli Progetto",
        submit: "Invia Richiesta",
        sending: "Invio in corso...",
        success: "Grazie! Ti contatteremo presto.",
        error: "Qualcosa è andato storto. Riprova.",
        validation: {
          nameRequired: "Per favore inserisci il tuo nome",
          emailRequired: "Per favore inserisci la tua email",
          emailInvalid: "Per favore inserisci un indirizzo email valido",
          messageRequired: "Per favore inserisci il tuo messaggio"
        }
      }
    },
    footer: {
      tagline: "Costruiamo il futuro, una soluzione alla volta.",
      rights: "Tutti i diritti riservati."
    }
  }
};
